module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Observe perpetually … Observe my own despondency. By that means it becomes serviceable. Or so I hope.")]), _vm._v(" "), _c('p', {
    staticClass: "EPS"
  }, [_vm._v("—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Diary of Virginia Woolf")]), _vm._v(", Volume V")]), _vm._v(" "), _c('p', {
    staticClass: "EPIF"
  }, [_vm._v("All my watercolors fade to black.")]), _vm._v(" "), _c('p', {
    staticClass: "EPS"
  }, [_vm._v("—Annie Lennox, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Pavement Cracks")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0